import { useNavigate } from "react-router-dom";

import { PageWrapper } from "./UnifiedRegistry/BreadcrumbsPageWrapper";

import RequestDisplay from "@/components/RequestDisplay";
import { RequestDisplayLoadingShimmer } from "@/components/RequestDisplay/RequestDisplayLoadingShimmer";
import { useRequest, useRequestBulk } from "@/queries";

export const RequestContent = ({ requestId }: { requestId: string }) => {
  const navigate = useNavigate();
  const requestPreview = useRequest(requestId);
  const requestBulk = useRequestBulk(requestId);

  if (requestId === "null") {
    navigate("/");
  }

  if (requestPreview.isLoading) {
    return (
      <PageWrapper>
        <RequestDisplayLoadingShimmer />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <RequestDisplay
        requestId={requestId}
        requestPreview={requestPreview.data}
        requestBulk={requestBulk.data}
      />
    </PageWrapper>
  );
};
